module.exports = __webpack_public_path__ + "media/images/modify_invitation_edit-0618ac0e.svg";